var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagecircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.8922H10L14.45 19.8323C15.11 20.2693 16 19.8024 16 19.0078V16.8922C19 16.8922 21 14.9057 21 11.9259V5.96631C21 2.98652 19 1 16 1H6C3 1 1 2.98652 1 5.96631V11.9259C1 14.9057 3 16.8922 6 16.8922Z",
    stroke: "#091F28",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagecircle);
export default __webpack_public_path__ + "static/media/messagecircle.c236a2a5bde2ae09d541894469eb6b1e.svg";
export { ForwardRef as ReactComponent };